export default "__VITE_ASSET__Lp4XgROs__"